import SHARED from '../../constants';
import FileTypeComponent from '../FileTypeComponent';
import styles from './styles.module.css';
import mp4 from '../../../../assets/imgs/fileTypes/mp4.png';
import React from 'react';
import SharedFunc from '../../functions/SharedFunc';

const ZoomModalContent = ({
  zoomContent,
  downloadedFiles,
  setDownloadedFiles,
  chatBody,
}) => {
  return (
    <div className={styles.container}>
      {zoomContent?.type == 'image' && (
        <FileTypeComponent
          path={SHARED?.socketServerImage}
          type="image"
          item={zoomContent?.item}
          downloadedFiles={downloadedFiles}
          chatBody={!chatBody}
          setDownloadedFiles={setDownloadedFiles}
        >
          <div
            className={`${styles.zoomImageContainer} ${styles.svgBackground}`}
          >
            <img
              src={`${SHARED?.socketServerImage}${zoomContent?.item?.file?.name}`}
              id={zoomContent?.item?.id}
            />
          </div>
        </FileTypeComponent>
      )}
      {zoomContent?.type == 'video' && (
        <FileTypeComponent
          path={SharedFunc(zoomContent?.item?.file?.serverId,'socketServerVideo')}
          type="video"
          item={zoomContent?.item}
          downloadedFiles={downloadedFiles}
          chatBody={!chatBody}
          setDownloadedFiles={setDownloadedFiles}
        >
          <video
            src={`${SharedFunc(zoomContent?.item?.file?.serverId,'socketServerVideo')}${zoomContent?.item?.file?.name}`}
            preload="none"
            id={`this${zoomContent?.item?.id}`}
            controls
          />
        </FileTypeComponent>
      )}
    </div>
  );
};
export default ZoomModalContent;
